export default "/images/f6d7e9f9886faf8ef0f91f2dbe88cb0a.avif";